<!--
 * @Descripttion: 基础抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 19:17:41
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-06-20 10:46:12
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="width"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<!-- 弹窗内容部分 -->
				<div class="filter-box pos-rela ml-16" style="height: auto">
					<el-input style="margin-right: 10px" placeholder="请输入" v-model="searchValue">
						<el-select v-model="selectOption" slot="prepend" placeholder="请选择" @change="changeSelect">
							<el-option :label="item.label" :value="item.value" v-for="item in dropdownList" :key="item.value"></el-option>
						</el-select>
					</el-input>
					<el-button class="searchBtn font-h3-regular" @click="search()">搜索</el-button>
				</div>
				<div class="tab mt-24">
					<el-table :data="list" class="table-small" :show-header="false" v-loading="tableLoading">
						<el-table-column>
							<template slot-scope="{ row }">
								<goods-item :row="row" :platformId="platformId" />
							</template>
						</el-table-column>
						<el-table-column width="120">
							<template slot-scope="{ row }">
								<el-button type="primary" size="mini" plain @click="selectGoods(row)">{{ row.isCommon ? '编辑商品' : '选择商品' }}</el-button>
							</template>
						</el-table-column>
					</el-table>
					<yx-pagination
						:total="total"
						:current-page="page.page_index"
						:page-size="page.page_size"
						@size-change="sizeChange"
						@current-change="currentChange"
						layout="total, sizes, prev, pager, next"
						:pager-count="5"
					></yx-pagination>
				</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { debounce } from 'lodash';
import goodsItem from './goodsItem.vue';
import { productCommonList } from '@/api/secondColonelManage';
export default {
	components: {
		goodsItem,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			title: '选择商品', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态
			searchValue: '',
			selectOption: 0,
			dropdownList: [
				{
					value: 0,
					label: '商品名称',
					key: 'productName',
				},
				{
					value: 1,
					label: '商品id',
					key: 'productId',
				},
			],
			list: [],
			total: 0, // 列表总数
			page: {
				page_index: 1, // 页码
				page_size: 20, // 每页条数
			},
			tableLoading: false,
			id: '',
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(id = '') {
			this.id = id;
			this.getList();
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.page = {
				page_index: 1,
				page_size: 20,
			};
			this.id = '';
			this.tableLoading = false;
			this.searchValue = '';
			this.selectOption = 0;
			this.visible = false;
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 抽屉尺寸，small:500px，default: 600px，normal:800px，large:1080px
			this.size = 'default';
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		changeSelect(e) {
			this.searchValue = '';
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.page.page_size = val;
			this.page.page_index = 1;
			this.getList();
		},
		// 页数变化
		currentChange(val) {
			this.page.page_index = val;
			this.getList();
		},
		async getList() {
			const { selectOption, searchValue, platformId } = this;
			this.tableLoading = true;
			let key = this.dropdownList.find(item => item.value === selectOption).key;
			let params = { [key]: searchValue };
			try {
				const { list = [], total = 0 } = await productCommonList({ ...this.page, ...params, platformId });
				this.total = total;
				this.list = list;
				this.tableLoading = false;
			} catch (e) {
				this.tableLoading = false;
			}
		},
		selectGoods(row) {
			this.$emit('selectGoods', row);
			this.handleClose();
		},
		search() {
			this.getList();
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.filter-box {
	.el-select {
		width: 100px;
		::v-deep {
			&.el-input__inner {
				height: 24px;
			}
			&.el-input__icon {
				line-height: 24px;
			}
		}
	}
	/deep/ .el-input-group__prepend {
		background-color: @color-white;
		border: 1px solid @color-gy5;
		border-right: none;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}
	.searchBtn {
		width: 56px;
		background-color: @color-primary;
		color: @color-white;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid @color-primary;
	}
}
</style>